import { useWorkspacesList } from "@api/workspace.api";
import { useScope } from "@state/scopeContext.lib";
import { useMemo } from "react";

export function useBillableClients() {
    const { organizationId } = useScope();

    const { data: workspaces } = useWorkspacesList({
        organizationId: organizationId ?? undefined,
        excludeDemoClient: true,
    });

    return useMemo(() => {
        if (!organizationId || !workspaces) {
            return [];
        }

        return (
            workspaces.filter(
                (workspace) =>
                    !workspace.isFirmWorkspace &&
                    workspace.organizationOwnsBilling,
            ) ?? []
        );
    }, [workspaces, organizationId]);
}
